import {arrayOperators, IArrayCondition} from './array-operators';
import {comparisonOperators, IComparisonCondition} from './comparison-operators';
import {ILogicalCondition, logicalOperators} from './logical-operators';

export type IFilterConditions = (IArrayCondition | IComparisonCondition | ILogicalCondition);

export const isArrayCondition = (filter: IFilterConditions): filter is IArrayCondition => {
    return filter.operator in arrayOperators;
};

export const isComparisonCondition = (filter: IFilterConditions): filter is IComparisonCondition => {
    return filter.operator in comparisonOperators;
};

export const isLogicalCondition = (filter: IFilterConditions): filter is ILogicalCondition => {
    return filter.operator in logicalOperators;
};
